export default "__VITE_ASSET__BZXZd_TU__"